export const LOCAL_STORAGE_DEVICE_ID_KEY = 'mdrt:web-push-device-id';
